import { removeAllFilterInfos } from './view/preferences';

/**
 * トークンの有効期限を確認する
 */
const confirmTokenExpiryDate = (): boolean => {
  // 現在の日付をunixtime形式で取得
  const currentDate = new Date().getTime();
  // ローカルストレージからトークンの有効期限を取得
  const res = localStorage.getItem('authInfo');
  if (!res) {
    // トークンの取得に失敗した場合は無効とする
    return false;
  }
  const authInfo = JSON.parse(res);
  // トークン情報を取得する
  const tokenInfo = authInfo.idToken;
  if (!tokenInfo) {
    // トークン情報がない場合は無効とする
    return false;
  }
  const splitToken = tokenInfo.split('.');
  // トークン情報をBase64からデコード
  const decodedToken = atob(splitToken[1]);

  // 有効期限の30分前を計算
  const confirmExpiryDate = JSON.parse(decodedToken).exp * 1000 - 30 * 60 * 1000;

  // 有効期限が現在の日付よりも未来であれば有効とする
  return confirmExpiryDate > currentDate;
};

/**
 * トークンが有効期限内でない場合、localStorageからvuexのstateを削除する
 */
export const removeTokenIfExpired = async (): Promise<boolean> => {
  if (!confirmTokenExpiryDate()) {
    localStorage.removeItem('authInfo');
    localStorage.removeItem('vuex');
    await removeAllFilterInfos();
    // ここでVuexのstateを更新する必要がある場合は、Vuexのstoreをインポートして更新する
    // 例: store.commit('auth/logout');
    return false;
  }
  return true;
};
